// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';

import { useTranslation } from 'react-i18next';
import React, { ReactElement, useEffect } from 'react';
import { useUser } from 'store/userContext';
import { Box, LoaderForm } from 'components';
import QualificationsRepository from 'api/repository/QualificationsRepository';
import TechnicalRepository from 'api/repository/TechnicalRepository';
import TransportRepository from 'api/repository/TransportRepository';
import QualificationsEnergy from './QualificationsEnergy';
import QualificationTechnicalUDT from './QualificationTechnicalUDT';
import './qualifications.scss';
import QualificationTechnicalTDT from './QualificationTechnicalTDT ';
import QualificationTechnicalDevice from './QualificationTechnicalDevice';
import AuthorizationEnergy from './AuthorizationEnergy';
import QualificationTransport from './QualificationTransport';
import AuthorizationTechnical from './AuthorizationTechnical';

const Panel = (): ReactElement => {
  const { t } = useTranslation('employee');
  const { userId, hydrated } = useUser();
  const [getQualificationsEnergy, dataQualificationsEnergy] =
    QualificationsRepository.useGetQualifications();

  const [getAuthorizationEnergy, dataAuthorizationEnergy] =
    QualificationsRepository.useGetAuthorizationEnergy();

  const [getTechnicalUDT, dataTechnicalUDT] =
    TechnicalRepository.useGetTechnicalUDT();

  const [getTechnicalTDT, dataTechnicalTDT] =
    TechnicalRepository.useGetTechnicalTDT();

  const [getTechnicalDevice, dataTechnicalDevice] =
    TechnicalRepository.useGetTechnicalDevice();

  const [getAuthorizationTechnical, dataAuthorizationTechnical] =
    TechnicalRepository.useGetAuthorizationTechnical();

  const [getTransportDriverLicense, dataTransportDriverLicense] =
    TransportRepository.useGetTransportDriveLicense();
  const [getTransportDangerousGoods, dataTransportDangerousGoods] =
    TransportRepository.useGetTransportDangerousGoods();

  useEffect(() => {
    if (userId && userId !== null) {
      getQualificationsEnergy({ userId });
      getAuthorizationEnergy({ userId });
      getTechnicalUDT({ userId });
      getTechnicalTDT({ userId });
      getTechnicalDevice({ userId });
      getAuthorizationTechnical({ userId });
      getTransportDriverLicense({ userId });
      getTransportDangerousGoods({ userId });
    }
  }, [userId]);

  return (
    <LoaderForm active={dataQualificationsEnergy === undefined} type="getData">
      <Box
        id="userQualificationsEnergyDesktop"
        name={t(`userQualificationsDesktop.qualifications`)}
        svgIcon="desktop"
        noContentStyle
      >
        {dataQualificationsEnergy &&
        Object.values(dataQualificationsEnergy).some(
          (arr) => arr.length > 0
        ) ? (
          <QualificationsEnergy
            userId={userId}
            dataQualificationsEnergy={dataQualificationsEnergy}
          />
        ) : (
          ''
        )}
        {dataAuthorizationEnergy &&
        Object.keys(dataAuthorizationEnergy)?.length > 0 ? (
          <AuthorizationEnergy
            userId={userId}
            dataAuthorizationEnergy={dataAuthorizationEnergy}
          />
        ) : (
          ''
        )}
        {dataTechnicalUDT && Object.keys(dataTechnicalUDT)?.length > 0 ? (
          <QualificationTechnicalUDT
            userId={userId}
            dataTechnicalUDT={dataTechnicalUDT}
          />
        ) : (
          ''
        )}
        {dataTechnicalTDT && Object.keys(dataTechnicalTDT)?.length > 0 ? (
          <QualificationTechnicalTDT
            userId={userId}
            dataTechnicalTDT={dataTechnicalTDT}
          />
        ) : (
          ''
        )}
        {dataTechnicalDevice && dataTechnicalDevice?.length > 0 ? (
          <QualificationTechnicalDevice
            userId={userId}
            dataTechnicalDevice={dataTechnicalDevice}
          />
        ) : (
          ''
        )}
        {dataAuthorizationTechnical &&
        Object.keys(dataAuthorizationTechnical)?.length > 0 ? (
          <AuthorizationTechnical
            userId={userId}
            dataAuthorizationTechnical={dataAuthorizationTechnical}
          />
        ) : (
          ''
        )}
        {(dataTransportDriverLicense &&
          Object.keys(dataTransportDriverLicense)?.length > 0) ||
        (dataTransportDangerousGoods &&
          Object.keys(dataTransportDangerousGoods)?.length > 0) ? (
          <QualificationTransport
            userId={userId}
            dataTransportDriverLicense={dataTransportDriverLicense}
            dataTransportDangerousGoods={dataTransportDangerousGoods}
          />
        ) : (
          ''
        )}

        {(dataQualificationsEnergy === null ||
          (dataQualificationsEnergy &&
            Object.keys(dataQualificationsEnergy)?.length === 0)) &&
        (dataAuthorizationEnergy === null ||
          (dataAuthorizationEnergy &&
            Object.keys(dataAuthorizationEnergy)?.length === 0)) &&
        (dataTechnicalUDT === null ||
          (dataTechnicalUDT && Object.keys(dataTechnicalUDT)?.length === 0)) &&
        (dataTechnicalTDT === null ||
          (dataTechnicalTDT && Object.keys(dataTechnicalTDT)?.length === 0)) &&
        (dataTechnicalDevice === null ||
          (dataTechnicalDevice &&
            Object.keys(dataTechnicalDevice)?.length === 0)) &&
        (dataAuthorizationTechnical === null ||
          (dataAuthorizationTechnical &&
            Object.keys(dataAuthorizationTechnical)?.length === 0)) &&
        (dataTransportDriverLicense === null ||
          (dataTransportDriverLicense &&
            Object.keys(dataTransportDriverLicense)?.length === 0)) &&
        (dataTransportDangerousGoods === null ||
          (dataTransportDangerousGoods &&
            Object.keys(dataTransportDangerousGoods)?.length === 0)) ? (
          <div className="noQualifications">Brak uprawnień</div>
        ) : (
          <></>
        )}
      </Box>
    </LoaderForm>
  );
};

export default Panel;
